import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
    providedIn: 'root',
})
export class DuprService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    syncPlayerData(id_site: string, external_id: string, person_id: string, rankings: {
        type: string;
        points: number;
        confidence_level: number;
    }[]): Observable<any> {
        const body = this.setBody();
        body.set('id_site', id_site);
        body.set('external_id', external_id);
        body.set('person_id', person_id);
        body.set('rankings', JSON.stringify(rankings));
        return this.http.post(this.urlService + this.routeAdress.route_dupr_sync_player_data, body.toString());
    }
}
